import { forwardRef, ReactNode } from 'react';
import { Stack, Typography, useTheme } from '@mui/material';

import {
	StyledCardListItemContainer,
	StyledLeftIconWrapper,
	StyledRightIconWrapper,
	TRUNCATE_TEXT_SX_PROPS,
} from './MplCardListItem.styled';

interface MplCardListItemProps {
	text: string;
	subtext?: string;
	leftIcon?: ReactNode;
	rightIcon?: ReactNode;
	onClick?: () => void;
	disabled?: boolean;
	testId?: string;
}

export const MplCardListItem = forwardRef<HTMLDivElement, MplCardListItemProps>(
	(
		{ text, subtext, leftIcon, rightIcon, onClick, disabled = false, testId },
		ref
	) => {
		const theme = useTheme();

		const handleClick = () => {
			if (!disabled && onClick) {
				onClick();
			}
		};

		return (
			<StyledCardListItemContainer
				ref={ref}
				disabled={disabled}
				hasIcon={!!leftIcon}
				onClick={handleClick}
				data-testid={testId}
			>
				{leftIcon && (
					<StyledLeftIconWrapper disabled={disabled}>
						{leftIcon}
					</StyledLeftIconWrapper>
				)}

				<Stack flex={1} minWidth={0} justifyContent="center" spacing={0}>
					<Typography
						variant="b2-m"
						data-testid="mpl-card-list-item-text"
						color={theme.palette.primary.main}
						sx={TRUNCATE_TEXT_SX_PROPS}
					>
						{text}
					</Typography>
					{subtext && (
						<Typography
							variant="l1"
							data-testid="mpl-card-list-item-subtext"
							color={theme.palette.solutions?.[600]}
							sx={TRUNCATE_TEXT_SX_PROPS}
						>
							{subtext}
						</Typography>
					)}
				</Stack>

				{rightIcon && (
					<StyledRightIconWrapper disabled={disabled}>
						{rightIcon}
					</StyledRightIconWrapper>
				)}
			</StyledCardListItemContainer>
		);
	}
);

MplCardListItem.displayName = 'MplCardListItem';
